import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/acesso/pais/';

class LocalidadeService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findAllByFiltro(filtro) {
        return axios.get(API_URL + 'filter?filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }
    
}

export default new LocalidadeService();